'use strict';

angular.module('ClinicApp').controller('ModalNoShowCancelDate', function($scope, $q, $modalInstance, appointment, OCUtil, AppointmentService) {
  $scope.appointment = appointment;
  $scope.userEntered = {};

  $scope.submit = function(form) {
    if (form.$invalid) {
      return $q.reject();
    }

    var appointmentTime = OCUtil.formatAppointmentTime($scope.userSelected.dateTimeResult);
    return AppointmentService.updateAppointment(
      $scope.appointment.id,
      appointmentTime.date,
      appointmentTime.startTime,
    ).then(function() {
      return AppointmentService.verifyAppointment($scope.appointment.id, {
        visited: false,
        anotherBooked: false,
      });
    })
      .then(function() {
        $modalInstance.close();
      });
  };

  $scope.cancel = function() {
    $modalInstance.dismiss('cancel');
  };
});
